//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useRef, useState } from 'react';

// *** MUI / STYLE ***
import { useTheme } from '@mui/material/styles';
import { 
  SignalWifiStatusbar4Bar,
  SignalWifiBad,
  SignalWifiStatusbarConnectedNoInternet4,
} from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';

// === API ===
import { on, removeListener } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function IconWebsocketConnection( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { styles } = props;

  const theme = useTheme();

  const [ is_open, setIsOpen  ] = useState( false );
  const [ message, setMessage ] = useState( '' );
  const [ color  , setColor   ] = useState( theme.palette.primary.main );
  const [ status , setStatus  ] = useState( 'connection' );

  const Icon = status == 'connection'     ? SignalWifiStatusbar4Bar
             : status == 'disconnection'  ? SignalWifiBad
             : status == 'reconnect-fail' ? SignalWifiBad
             : status == 'reconnection'   ? SignalWifiStatusbarConnectedNoInternet4
             : SignalWifiBad;
             
  const ref_timeout_close = useRef(null);

  //#endregion

  //#region [STYLES]

  const position   = { position: 'absolute', top: '60px', right: '20px', zIndex: 1000 };
  const size       = { width: 'fit-content', height: '30px' };
  const center     = { alignItems: 'center' };
  const padding    = { padding: '4px', paddingLeft: '10px', paddingRight: '10px' };
  const background = { background: color };
  const border     = { borderRadius: '5px' };
  const is_visible = { display: is_open ? 'flex' : 'none' };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {

    //-----------------------------------------------------------------
    function handleDisconnect() {
      //-----------------------------------------------------------------
      setMessage( 'You have disconnected from the server.' );
      setColor( theme.palette.error.main );
      setStatus( 'disconnection' );
      setIsOpen( true );
      closeTimer();
    }

    //-----------------------------------------------------------------
    function handleReconnect() {
      //-----------------------------------------------------------------
      setMessage( 'Attempting to reconnect to the server.' );
      setColor( 'orange' );
      setStatus( 'reconnection' );
      setIsOpen( true );
      closeTimer();
    }

    //-----------------------------------------------------------------
    function handleReconnectFail() {
      //-----------------------------------------------------------------
      setMessage( 'Failed to reconnect to the server.' );
      setColor( theme.palette.error.main );
      setStatus( 'reconnect-fail' );
      setIsOpen( true );
      closeTimer();
    }

    //-----------------------------------------------------------------
    function handleConnection() {
      //-----------------------------------------------------------------
      setMessage( 'Connected to the server.' );
      setColor( theme.palette.success.main );
      setStatus( 'connection' );
      setIsOpen( true );
      closeTimer();
    }

    on(  'disconnection', handleDisconnect    );
    on(   'reconnection', handleReconnect     );
    on( 'reconnect-fail', handleReconnectFail );
    on(     'connection', handleConnection    );

    return () => {
      removeListener(  'disconnection', handleDisconnect    );
      removeListener(   'reconnection', handleReconnect     );
      removeListener( 'reconnect-fail', handleReconnectFail );
      removeListener(     'connection', handleConnection    );
    }

  }, [] );

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onMouseOver() {
    //-----------------------------------------------------------------
    setIsOpen( true );
  }

  //-----------------------------------------------------------------
  function onMouseLeave() {
    //-----------------------------------------------------------------
    setIsOpen( false );
  }

  //#endregion

  //#region

  //-----------------------------------------------------------------
  function closeTimer() {
    //-----------------------------------------------------------------
    clearTimeout( ref_timeout_close.current );

    ref_timeout_close.current = setTimeout( () => {
      setIsOpen( false );
    }, 5000 );
  }

  //#endregion

  return (
    <>
      <Icon style={{color}} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave} />
      <Styled styles={[is_visible, position, size, padding, center, background, border]}>
        {message}
      </Styled>
    </>
  )
}